/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../common/identifier/account_scoped_identifier';
import '../../../common/time';
import '../../../connect/v2/common/money';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "dashboard": {
            "nested": {
              "withholding_config": {
                "nested": {
                  "WithholdingConfig": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "isEnabled": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      },
                      "withholdingBps": {
                        "type": "int32",
                        "id": 3,
                        "rule": "optional"
                      },
                      "owner": {
                        "type": ".squareup.bbfrontend.common.account_scoped_identifier.AccountScopedIdentifier",
                        "id": 4,
                        "rule": "optional"
                      },
                      "version": {
                        "type": "int32",
                        "id": 5,
                        "rule": "optional"
                      },
                      "effectiveEndAt": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 6,
                        "rule": "optional"
                      }
                    }
                  },
                  "AccountWithholdingConfig": {
                    "fields": {
                      "accountId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "targetAmount": {
                        "type": ".squareup.connect.v2.common.Money",
                        "id": 2,
                        "rule": "optional"
                      },
                      "completedAt": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 3,
                        "rule": "optional"
                      },
                      "withholdingConfigs": {
                        "type": ".squareup.bbfrontend.dashboard.withholding_config.WithholdingConfig",
                        "id": 4,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.withholding_config?.nested?.WithholdingConfig && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.withholding_config?.nested?.AccountWithholdingConfig) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE WithholdingConfig @ squareup/bbfrontend/dashboardweb/withholding_config/withholding_config.proto at 14:1
 */
export const WithholdingConfig = $root.lookupType('squareup.bbfrontend.dashboard.withholding_config.WithholdingConfig');
fixType(WithholdingConfig, {
  isEnabled: {
    required: true
  },
  withholdingBps: {
    required: true
  },
  owner: {
    required: true
  }
});
Builder.createAndAttachToType(WithholdingConfig);
/**
 * SOURCE AccountWithholdingConfig @ squareup/bbfrontend/dashboardweb/withholding_config/withholding_config.proto at 27:1
 */
export const AccountWithholdingConfig = $root.lookupType('squareup.bbfrontend.dashboard.withholding_config.AccountWithholdingConfig');
fixType(AccountWithholdingConfig, {
  accountId: {
    required: true
  },
  withholdingConfigs: {
    required: true
  }
});
Builder.createAndAttachToType(AccountWithholdingConfig);